import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import client from "@/lib/api";
import PolicyLayout, { Section } from "@/components/PolicyLayout";

// Public on purpose: payment providers expect a reachable policy page, and the
// rules are read from the API so this page cannot drift from what the code does.
export default function RefundPolicy() {
    const [rules, setRules] = useState(null);

    useEffect(() => {
        client.get("/refund-policy")
            .then((r) => setRules(r.data.rules || []))
            .catch(() => setRules([]));
    }, []);

    return (
        <PolicyLayout
            eyebrow="Payments" title="When money comes back to you." testId="refund-policy"
            intro="Every Tales with Terry book is illustrated to order for one family, so a confirmed order isn't something we can put back on a shelf. What we always return is money that never bought anything.">

            <Section heading="The rules">
                {rules === null ? (
                    <div className="text-plum/50">Loading…</div>
                ) : (
                    <ul className="space-y-4">
                        {rules.map((r, i) => (
                            <li key={i} className="flex gap-3">
                                <ShieldCheck className="w-4 h-4 text-bubblegum shrink-0 mt-0.5" />
                                <span>{r}</span>
                            </li>
                        ))}
                    </ul>
                )}
            </Section>

            <Section heading="How to tell us">
                <p>
                    If money left your account and the order never confirmed, open{" "}
                    <Link to="/library" className="underline hover:text-plum">your library</Link> and use
                    “Money taken but not confirmed?” on that order. Include the UPI or bank reference if
                    you have it — it's what lets us find the payment fastest.
                </p>
                <p>
                    Anything else, the <Link to="/contact" className="underline hover:text-plum">contact page</Link> reaches a person.
                </p>
            </Section>
        </PolicyLayout>
    );
}
